import { PartialCarConfiguration } from '~/app/market-config/models/car-confi-market-configuration';
import { JETSTREAM_SERVER_US } from '~/app/models/constans';

export const local: PartialCarConfiguration = {
	hasJetStream: true,
	JetStreamServerUrl: JETSTREAM_SERVER_US,
	showCaESummaryText: true,
	engineCardKeyfacts: ['acceleration', 'maxPowerHp', 'chargingTime'],
	packagesFilter: {
		filterByFeatureState: ['available'],
		filterByFeatureTypes: {
			featureTypes: ['EQUIPMENT'],
		},
		filterByGroupIds: {
			groupIds: [],
			mode: 'EXCLUSIVE',
		},
	},
	uiPreferences: {
		prices: {
			totalPriceFrom: 'totalWithCharges',
			hiddenPriceParts: ['totalWithCharges', 'modelPriceWithFees', 'total'],
			vatConfig: {
				feature: 'hidden',
				trimlineAndEngine: 'hidden',
				totalPrice: 'hidden',
				priceParts: {},
			},
		},
	},
	useStaticPriceDateRemark: true,
	hideConsumptionEmissionEngineName: true,
	displayOnlyPackageCat: true,
	showFeesOnSummaryPage: true,
};
